export const navLinks = [
  { label: "Home", href: "/" },
  { label: "Services", href: "#services" },
  { label: "About Us", href: "#about" },
  { label: "How It Works", href: "#works" },
  { label: "Contact Us", href: "#contact" },
];
